import { clearHeldTenant, endSession, recordIdleEnd, type IdleRestore } from '@/lib/tenant/tenant-session'

type Logout = (options: ReturnType<typeof auth0LogoutOptions>) => unknown

/*
 * Auth0 logout options for Admin South Downs. Always send the user back to this
 * app's origin so Auth0 ends its session and AuthGate can open hosted sign-in
 * (ONC-82 AC6 / VIS-319). Do not return to an in-app Login CTA.
 */
export function auth0LogoutOptions(origin: string = window.location.origin) {
  return {
    logoutParams: { returnTo: origin },
  } as const
}

/**
 * Explicit sign-out. Clears the held tenant and any idle record before ending
 * the Auth0 session, so the next sign-in follows the ordinary tenant rules.
 */
export function signOut(logout: Logout) {
  endSession()
  return logout(auth0LogoutOptions())
}

/**
 * Ends a session because it went idle, so the next sign-in restores `tenantId`
 * when the user may still act in it (VIS-326 AC 4).
 *
 * Contract for VIS-333: call this, in the same tab, as the only way an idle
 * session ends. Never call `signOut` or `logout` directly for idle expiry —
 * `signOut` clears the idle record and so prevents the restore.
 */
export function endIdleSession(logout: Logout, record: IdleRestore) {
  clearHeldTenant()
  recordIdleEnd(record)
  return logout(auth0LogoutOptions())
}
